import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const TabFilterContainer = styled.div`
  display: flex;
  gap: 0;
  margin-bottom: 16px;
  width: fit-content;
`;

const TabFilterButton = styled.button`
  min-width: 100px;
  padding: 5px 10px;
  font-size: 0.8rem;
  font-weight: bold;
  text-align: center;
  color: ${props => (props.active ? props.theme.white : props.theme.wbcBlue)};
  background-color: ${props => (props.active ? props.theme.wbcBlue : "transparent")};
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;

  &:first-child {
    border-left: none;
  }
`;

const TabFilter = ({ tabs, activeTab, onTabChange }) => {
  return (
    <TabFilterContainer>
      {tabs.map(tab => (
        <TabFilterButton key={tab.value} active={activeTab === tab.value} onClick={() => onTabChange(tab.value)}>
          {tab.label}
        </TabFilterButton>
      ))}
    </TabFilterContainer>
  );
};

TabFilter.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired
};

export default TabFilter;
